import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from '@mui/material/Button';
import DeliveryModal from '../Views/OrderOptions/DeliveryModal';
import { toast } from 'react-toastify';
import { connect, useSelector } from 'react-redux';
import jwtDecode from 'jwt-decode';
import * as geolib from 'geolib';
import { Link, useHistory } from 'react-router-dom';
import { addAddressUser, addressesList, getDeliveryStores, getTimezone, getTimezoneForLater, saveCart, saveDeliveryAddress, saveExtraAddress, saveGeoCodedAddress, saveOrderLaterDateTime, saveOrderTime, saveOrderType, saveSelectStoreId, setPositionProps, setSearchStringProps, storeMenuItemCall } from '../Redux';
import _ from 'lodash';
import domPurify from './dompurify';
import { saveStorePosFee } from '../Redux/actions/store';
import useCurrentLocale from '../hooks/useLanguage';
import { useTranslation } from 'react-i18next';
import { removeCoupon } from '../Redux/actions/menu';

function DeliveryFor(props: any) {
    let token = localStorage.getItem("userToken")
    let userData: any = token ? jwtDecode(token) : null
    const orderType = useSelector((state: any) => state.payment.orderType);
    let cartData = useSelector((state: any) => state.cart.cartData)
    const storeSelected = useSelector((state: any) => state.store.storeSelected);
    const deliveryStoreList = useSelector((state: any) => state.store.menuDeliveryStoreList);
    const delivery_address = useSelector((state: any) => state.payment.delivery_address);
    const propsPosition = useSelector((state: any) => state.payment.position);
    const propsSearchString: any = useSelector((state: any) => state.payment.searchString);
    const [show, showModal] = useState(false);
    const [orderTime, setOrderTime] = useState("now")
    const [validTimeFlag, setValidTimeFlag] = useState(false);
    const [lat, setLat] = useState("")
    const [lng, setLng] = useState("")
    let [laterdatetime, setLaterDate] = useState("")
    const [savedAddresses, setSaveAddressData] = useState<any>([])
    const [selectedAddress, setAddressData]: any = useState(null)
    const [position, setPosition] = useState(propsPosition)
    const [searchString, setSearchString] = useState(propsSearchString)
    const [extraDetails, setExtraDetails] = useState("")
    const [streetName, setStreetName] = useState("")
    const [streetNumber, setStreetNumber] = useState("")
    const [saveAddressCheck, setSaveAddress] = useState(false);
    const [place, setPlace] = useState("")
    const [open, cartShowModal] = useState(false);
    const addressData = useSelector((state: any) => state.customer.addressData);
    const isLogged = useSelector((state: any) => state.customer.isLogged);
    const [saveAddressSelect, setSaveAddressSelect] = useState(false)
    const [confirmAdd, setConfirmAddress] = useState(false);
    const [changeLocation, setChangeLocation] = useState(false)
    const pathname = window.location.pathname;
    const lang = useCurrentLocale();

    useEffect(() => {
        if (addressData && addressData.length > 0) {
            let index = addressData.findIndex((obj: any, index: any) => {
                return obj.is_default == 1
            });

            if (index !== -1) {
                const shiftedElement = addressData.splice(index, 1)[0];
                addressData.unshift(shiftedElement);
            }
        }
        setSaveAddressData(addressData)
    }, [addressData])
    const handleOnChange = (obj: any) => {
        setAddressData(obj)
        setExtraDetails(obj.extra_details)
        setStreetName(obj.street_name)
        setStreetNumber(obj.street_number)
        setSearchString(obj.full_address)
        setLat(obj.lat)
        setLng(obj.lng)
        let data: any = {
            lat: obj.lat,
            lng: obj.lng
        }
        setPosition(data);
        setChangeLocation(false)
        setConfirmAddress(false)
        // let doc: any = document.getElementById('txtSearch');
        // if (doc) {
        //     doc.value = obj.full_address;
        // }
    }

    const handleCartRemove = () => {
        let data: any = []
        for (let i = 0; i < deliveryStoreList.length; i++) {
            if (deliveryStoreList[i].trade_zone_id.zone_json) {
                if (geolib.isPointInPolygon({ latitude: lat, longitude: lng }, JSON.parse(deliveryStoreList[i].trade_zone_id.zone_json))) {
                    data.push(deliveryStoreList[i]);
                }
            }
        }
        if (data.length > 0) {
            if (orderTime == "later") {
                if (data[0].isDays == 0) {
                    compareLaterOpenClosingTime(data[0]);
                } else if (data[0].isDays == 1) {
                    compareLaterTimingbyEachDay(data[0])
                }
            } else if (orderTime == "now") {
                if (data[0].isDays == 0) {
                    compareOpenClosingTime(data[0])
                } else if (data[0].isDays == 1) {
                    compareTimingbyEachDay(data[0], "delivery")
                }
            }
        } else {
            toast.error(t("DELIVERY_NOT_AVAILABLE"), {
                position: toast.POSITION.TOP_RIGHT,
                hideProgressBar: true,
                autoClose: 3000,
            });
        }
    }
    const cartCloseModal = () => {
        cartShowModal(false)
    }
    const handleClose = () => {
        showModal(false);
        cartShowModal(false);
    }
    const deliveryOrderReady = () => {
        if (orderTime == "now") {
            if (saveAddressSelect) {
                if (saveAddressCheck) {
                    return (lat !== "" && lng !== "" && place !== "")
                } else {
                    return (lat !== "" && lng !== "")
                }
            } else {
                if (saveAddressCheck) {
                    return (lat !== "" && lng !== "" && extraDetails !== "" && extraDetails !== undefined && streetName !== "" && streetName !== undefined && streetNumber !== "" && streetNumber !== undefined && place !== "")
                } else {
                    return (lat !== "" && lng !== "" && extraDetails !== "" && extraDetails !== undefined && streetName !== "" && streetName !== undefined && streetNumber !== "" && streetNumber !== undefined)
                }
            }
        } else {
            if (saveAddressSelect) {
                if (saveAddressCheck) {
                    return (lat !== "" && lng !== "" && orderTime == "later" && laterdatetime !== "" && validTimeFlag && place !== "")
                } else {
                    return (lat !== "" && lng !== "" && orderTime == "later" && laterdatetime !== "" && validTimeFlag)
                }
            } else {
                if (saveAddressCheck) {
                    return (lat !== "" && lng !== "" && orderTime == "later" && extraDetails !== "" && extraDetails !== undefined && streetName !== "" && streetName !== undefined && streetNumber !== "" && streetNumber !== undefined && laterdatetime !== "" && validTimeFlag && place !== "")
                } else {
                    return (lat !== "" && lng !== "" && orderTime == "later" && extraDetails !== "" && extraDetails !== undefined && streetName !== "" && streetName !== undefined && streetNumber !== "" && streetNumber !== undefined && laterdatetime !== "" && validTimeFlag)
                }
            }
        }
    }
    const checkAddress = () => {
        let obj: any = {
            extra_details: extraDetails,
            full_address: searchString,
            street_name: streetName,
            street_number: streetNumber,
            place: place,
            customer_id: userData.customer.customer_id,
            lat: lat,
            lng: lng,
            is_default: 0
        }
        let arr = addressData.filter((address: any) => {
            return address.place == place
        })

        if (arr && arr.length > 0) {
            if (place == 'home' || place == 'office') {
                if (arr.length >= 1) {
                    toast.error(`${t("ONE_ADDRESS_ALLOWED")} ${place}`, { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 })
                    return false
                } else {
                    props.addAddressUser(obj)
                    return true
                }
            } if (place == 'other') {
                props.addAddressUser(obj)
                return true
            }
        } else {
            props.addAddressUser(obj)
            return true
        }
    }
    const saveDeliveryStore = (storeSelected: any) => {
        if (open) {
            props.saveCart([])
        }
        let extraDetailsAddress = extraDetails;
        if (saveAddressCheck) {
            let response = checkAddress()
            if (response) {
                props.saveDeliveryAddress(streetName + " / " + streetNumber + " / " + extraDetailsAddress + " / " + searchString)
                props.saveGeoCodedAddress(searchString)
                props.saveExtraAddress(extraDetailsAddress)
                props.saveSelectStoreId(storeSelected)
                props.saveStorePosFee(storeSelected.pos_service_fee)
                props.removeCoupon()
                props.saveOrderType("Delivery")
                props.saveOrderTime(orderTime)
                //for reducers
                props.setPositionProps(position)
                props.setSearchStringProps(searchString)
                // let fullAddress = searchString;
                // let extraDetails: any = streetName + " " + streetNumber + " " + extraDetailsAddress;
                // !saveAddressSelect && saveAddressDetails({ fullAddress, extraDetails, coordinates: [position.lng, position.lat] }, apiKey)
                if (orderTime == "later") {
                    props.saveOrderLaterDateTime(laterdatetime)
                } else {
                    props.saveOrderLaterDateTime(null)
                }
                props.storeMenuItemCall(storeSelected.store_id, "Delivery", pathname,lang)
                handleClose()
                if (props.handleSelectStoreClose) {
                    props.handleSelectStoreClose()
                }
                setSaveAddress(false)
                setPlace("")
            }
        } else {
            props.saveDeliveryAddress(streetName + " / " + streetNumber + " / " + extraDetailsAddress + " / " + searchString)
            props.saveGeoCodedAddress(searchString)
            props.saveExtraAddress(extraDetailsAddress)
            props.saveSelectStoreId(storeSelected)
            props.saveStorePosFee(storeSelected.pos_service_fee)
            props.removeCoupon()
            props.saveOrderType("Delivery")
            props.saveOrderTime(orderTime)
            //for reducers
            props.setPositionProps(position)
            props.setSearchStringProps(searchString)
            // let fullAddress = searchString;
            // let extraDetails: any = streetName + " " + streetNumber + " " + extraDetailsAddress;
            // !saveAddressSelect && saveAddressDetails({ fullAddress, extraDetails, coordinates: [position.lng, position.lat] }, apiKey)
            if (orderTime == "later") {
                props.saveOrderLaterDateTime(laterdatetime)
            } else {
                props.saveOrderLaterDateTime(null)
            }
            props.storeMenuItemCall(storeSelected.store_id, "Delivery", pathname,lang)
            handleClose()
            if (props.handleSelectStoreClose) {
                props.handleSelectStoreClose()
            }
            setSaveAddress(false)
            setPlace("")
        }
        setConfirmAddress(false)
        let windowObj = (window as any)
        windowObj.dataLayer.push({ ecommerce: null });
        windowObj.dataLayer.push({
            'event': 'delivery',
            'ecommerce': {
                'select': {
                    'channel': "delivery"
                }
            }
        });
    }
    const handleSelectChannel = () => {
        let windowObj = (window as any)
        windowObj.dataLayer.push({ ecommerce: null });
        windowObj.dataLayer.push({
            'event': 'screenview_location'
        })
        props.getDeliveryStores();
        if (isLogged) {
            props.addressesList()
            setTimeout(() => {
                showModal(true)
            }, 500)
        } else {
            showModal(true)
        }
    }
    const closeModal = () => {
        if (!savedAddresses || savedAddresses.length === 0) {
            setPosition(null)
            setLat("")
            setLng("")
            setSearchString("")
            setExtraDetails("")
            setStreetName("")
            setStreetNumber("")
            setSaveAddressSelect(false)
            setAddressData(null)
        }
        setConfirmAddress(false)
        showModal(false)
    }
    const confirmLocation = () => {
        let cart = cartData;
        if (cart && cart.length > 0 && storeSelected) {
            showModal(false);
            // handleCartRemove()
            cartShowModal(true)
        } else {
            let data: any = []
            for (let i = 0; i < deliveryStoreList.length; i++) {
                if (deliveryStoreList[i].trade_zone_id.zone_json) {
                    if (geolib.isPointInPolygon({ latitude: lat, longitude: lng }, JSON.parse(deliveryStoreList[i].trade_zone_id.zone_json))) {
                        data.push(deliveryStoreList[i]);
                    }
                }
            }
            if (data.length > 0) {
                if (data[0]?.channel_active) {
                    if (orderTime == "later") {
                        if (data[0].isDays == 0) {
                            compareLaterOpenClosingTime(data[0]);
                        } else if (data[0].isDays == 1) {
                            compareLaterTimingbyEachDay(data[0])
                        }
                    } else if (orderTime == "now") {
                        if (data[0].isDays == 0) {
                            compareOpenClosingTime(data[0])
                        } else if (data[0].isDays == 1) {
                            compareTimingbyEachDay(data[0], "delivery")
                        }
                    }
                } else toast.error(t("STORE_CLOSED"))
            } else {
                toast.error(t("DELIVERY_NOT_AVAILABLE"), {
                    position: toast.POSITION.TOP_RIGHT,
                    hideProgressBar: true,
                    autoClose: 3000,
                });
            }
        }

    }
    const HoursArray = (hourDiff: any, starttime: any) => {
        if (String(hourDiff).indexOf('-') !== -1) {
            hourDiff = hourDiff + 24;
        }
        var hours: any = [];
        let hour = starttime;
        for (let i = 0; i <= hourDiff; i++) {
            hour = starttime + i;
            let AmOrPm = '';
            hour >= 12 && hour < 24 ? (AmOrPm = 'pm') : (AmOrPm = 'am');
            hour = hour % 12 || 12;
            hours.push(hour + AmOrPm);
        }
        var string = hours.join(':');
        return string;
    };
    //Later Case
    const compareLaterOpenClosingTime = (storeSelected: any) => {
        props.getTimezoneForLater(storeSelected.store_id).then((serverTime: any) => {
            let dateIndexServer = serverTime.date.indexOf("T")
            let serverDate = serverTime.date.slice(0, dateIndexServer)
            let dateIndexClient = laterdatetime.indexOf("T")
            let clientDate = laterdatetime.slice(0, dateIndexClient)
            let todayValidDate: any = new Date();
            let t = todayValidDate.getDate()
            let validDate = parseInt(t) == parseInt(serverDate.split("-")[2]) && serverDate.split("-")[0] == clientDate.split("-")[0] && serverDate.split("-")[1] == clientDate.split("-")[1] && (parseInt(serverDate.split("-")[2]) == parseInt(clientDate.split("-")[2]) || parseInt(serverDate.split("-")[2]) == parseInt(clientDate.split("-")[2]))
            if (validDate) {
                let addedTime: any = null;
                let today = new Date();
                let todayHours = today.getHours()

                if (todayHours != parseInt(serverTime.time.split(":")[0])) {
                    toast.error(t("INVALID_DEVICE_TIME"), {
                        position: toast.POSITION.TOP_RIGHT,
                        hideProgressBar: true,
                        autoClose: 3000,
                    });
                }
                let laterDate = new Date(laterdatetime);
                let futureHours: any = laterDate.getHours();
                let futureMinutes: any = laterDate.getMinutes();

                if (addedTime) {
                    futureHours = addedTime.split(":")[0];
                    futureMinutes = addedTime.split(":")[1];
                }

                let futureAmOrPm = futureHours >= 12 ? 'pm' : 'am';
                futureHours = futureHours % 12 || 12;
                let futuretime: any = futureHours + '' + futureAmOrPm;
                //define hours or minutes
                var timeStartMin = new Date(
                    '01/01/2007 ' + storeSelected.store_open_time,
                ).getMinutes();
                var timeEndMin = new Date(
                    '01/01/2007 ' + storeSelected.store_close_time,
                ).getMinutes();
                var timeStartHours = new Date(
                    '01/01/2007 ' + storeSelected.store_open_time,
                ).getHours();
                var timeEndHours = new Date(
                    '01/01/2007 ' + storeSelected.store_close_time,
                ).getHours();
                var hourDiff: any = timeEndHours - timeStartHours;
                let HourString = HoursArray(hourDiff, timeStartHours);
                let splitHourArray = HourString.split(":")
                if (splitHourArray.indexOf(futuretime) !== -1) { //if Pick Hour with am/pm is exist in HourString
                    if (timeStartMin == 0 && timeEndMin == 0) {  //if store opening minutes and closing minutes are 00
                        if (splitHourArray.length - 1 == splitHourArray.indexOf(futuretime)) {
                            //if Pick Hour with am/pm is exist in HourString at last index
                            if (storeSelected.mainStoreId.length > 0 && storeSelected.mainStoreId[0].backupStoreId.backup_zone_id) {
                                if (geolib.isPointInPolygon({ latitude: lat, longitude: lng }, JSON.parse(storeSelected.mainStoreId[0].backupStoreId.backup_zone_id.zone_json))) {
                                    saveDeliveryStore(storeSelected.mainStoreId[0].backupStoreId);
                                } else {
                                    toast.error(t("STORE_CLOSED"), {
                                        position: toast.POSITION.BOTTOM_RIGHT,
                                        hideProgressBar: true,
                                        autoClose: 3000,
                                    });
                                }
                            } else {
                                toast.error(t("STORE_CLOSED"), {
                                    position: toast.POSITION.BOTTOM_RIGHT,
                                    hideProgressBar: true,
                                    autoClose: 3000,
                                });
                            }
                        } else {
                            saveDeliveryStore(storeSelected);
                        }
                    } else {
                        if (timeStartMin == 0 || timeEndMin == 0) {  //if store opening or closing minute is 00
                            if (splitHourArray.length - 1 == splitHourArray.indexOf(futuretime)) {
                                if (futureMinutes < timeEndMin) {
                                    saveDeliveryStore(storeSelected);
                                } else {
                                    if (storeSelected.mainStoreId.length > 0 && storeSelected.mainStoreId[0].backupStoreId.backup_zone_id) {
                                        if (geolib.isPointInPolygon({ latitude: lat, longitude: lng }, JSON.parse(storeSelected.mainStoreId[0].backupStoreId.backup_zone_id.zone_json))) {
                                            saveDeliveryStore(storeSelected.mainStoreId[0].backupStoreId);
                                        } else {
                                            toast.error(t("STORE_CLOSED"), {
                                                position: toast.POSITION.BOTTOM_RIGHT,
                                                hideProgressBar: true,
                                                autoClose: 3000,
                                            });
                                        }
                                    } else {
                                        toast.error(t("STORE_CLOSED"), {
                                            position: toast.POSITION.BOTTOM_RIGHT,
                                            hideProgressBar: true,
                                            autoClose: 3000,
                                        });
                                    }
                                }
                            } else {
                                saveDeliveryStore(storeSelected);
                            }
                        } else { //if store opening or closing minute is not 00
                            if (
                                futureMinutes > timeStartMin ||
                                futureMinutes < timeEndMin
                            ) {
                                saveDeliveryStore(storeSelected);
                            } else {
                                if (storeSelected.mainStoreId.length > 0 && storeSelected.mainStoreId[0].backupStoreId.backup_zone_id) {
                                    if (geolib.isPointInPolygon({ latitude: lat, longitude: lng }, JSON.parse(storeSelected.mainStoreId[0].backupStoreId.backup_zone_id.zone_json))) {
                                        saveDeliveryStore(storeSelected.mainStoreId[0].backupStoreId);
                                    } else {
                                        toast.error(t("STORE_CLOSED"), {
                                            position: toast.POSITION.BOTTOM_RIGHT,
                                            hideProgressBar: true,
                                            autoClose: 3000,
                                        });
                                    }
                                } else {
                                    toast.error(t("STORE_CLOSED"), {
                                        position: toast.POSITION.BOTTOM_RIGHT,
                                        hideProgressBar: true,
                                        autoClose: 3000,
                                    });
                                }
                            }
                        }
                    }
                } else {
                    if (storeSelected.mainStoreId.length > 0 && storeSelected.mainStoreId[0].backupStoreId.backup_zone_id) {
                        if (geolib.isPointInPolygon({ latitude: lat, longitude: lng }, JSON.parse(storeSelected.mainStoreId[0].backupStoreId.backup_zone_id.zone_json))) {
                            saveDeliveryStore(storeSelected.mainStoreId[0].backupStoreId);
                        } else {
                            toast.error(t("STORE_CLOSED"), {
                                position: toast.POSITION.BOTTOM_RIGHT,
                                hideProgressBar: true,
                                autoClose: 3000,
                            });
                        }
                    } else {
                        toast.error(t("STORE_CLOSED"), {
                            position: toast.POSITION.BOTTOM_RIGHT,
                            hideProgressBar: true,
                            autoClose: 3000,
                        });
                    }
                }
            } else {
                toast.error(t("INVALID_DEVICE_TIME"), {
                    position: toast.POSITION.TOP_RIGHT,
                    hideProgressBar: true,
                    autoClose: 3000,
                });
            }
        })
    }
    const compareLaterTimingbyEachDay = (storeSelected: any) => {
        props.getTimezoneForLater(props.storeSelected.store_id).then((serverTime: any) => {
            let dateIndexServer = serverTime.date.indexOf("T")
            let serverDate = serverTime.date.slice(0, dateIndexServer)
            let dateIndexClient = laterdatetime.indexOf("T")
            let clientDate = laterdatetime.slice(0, dateIndexClient)
            let todayValidDate: any = new Date();
            let t = todayValidDate.getDate()
            let validDate = parseInt(t) == parseInt(serverDate.split("-")[2]) && serverDate.split("-")[0] == clientDate.split("-")[0] && serverDate.split("-")[1] == clientDate.split("-")[1] && (parseInt(serverDate.split("-")[2]) == parseInt(clientDate.split("-")[2]) || parseInt(serverDate.split("-")[2]) + 1 == parseInt(clientDate.split("-")[2]))
            if (validDate) {
                let today = new Date();
                let todayHours = today.getHours()

                if (todayHours != parseInt(serverTime.time.split(":")[0])) {
                    toast.error(t("INVALID_DEVICE_TIME"), {
                        position: toast.POSITION.TOP_RIGHT,
                        hideProgressBar: true,
                        autoClose: 3000,
                    });
                }
                let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                let weekDaysTimingArr = JSON.parse(storeSelected.daysTiming)
                let futureDay = new Date(laterdatetime).getDay();
                let dayName = days[futureDay];
                weekDaysTimingArr.map((storeDay: any) => {
                    if (dayName == storeDay.day) {
                        let laterDate = new Date(laterdatetime);
                        let futureHours: any = laterDate.getHours();
                        let futureMinutes: any = laterDate.getMinutes();
                        let futureAmOrPm = futureHours >= 12 ? 'pm' : 'am';
                        futureHours = futureHours % 12 || 12;
                        let futuretime: any = futureHours + '' + futureAmOrPm;
                        //define hours or minutes
                        var timeStartMin = new Date(
                            '01/01/2007 ' + storeDay.opening,
                        ).getMinutes();
                        var timeEndMin = new Date(
                            '01/01/2007 ' + storeDay.closing,
                        ).getMinutes();
                        var timeStartHours = new Date(
                            '01/01/2007 ' + storeDay.opening,
                        ).getHours();
                        var timeEndHours = new Date(
                            '01/01/2007 ' + storeDay.closing,
                        ).getHours();
                        var hourDiff: any = timeEndHours - timeStartHours;
                        let HourString = HoursArray(hourDiff, timeStartHours);
                        let splitHourArray = HourString.split(":")
                        if (splitHourArray.indexOf(futuretime) !== -1) { //if Pick Hour with am/pm is exist in HourString
                            if (timeStartMin == 0 && timeEndMin == 0) {  //if store opening minutes and closing minutes are 00
                                if (splitHourArray.length - 1 == splitHourArray.indexOf(futuretime)) {
                                    //if Pick Hour with am/pm is exist in HourString at last index
                                    if (storeSelected.mainStoreId.length > 0 && storeSelected.mainStoreId[0].backupStoreId.backup_zone_id) {
                                        if (geolib.isPointInPolygon({ latitude: lat, longitude: lng }, JSON.parse(storeSelected.mainStoreId[0].backupStoreId.backup_zone_id.zone_json))) {
                                            saveDeliveryStore(storeSelected.mainStoreId[0].backupStoreId);
                                        } else {
                                            toast.error(t("STORE_CLOSED"), {
                                                position: toast.POSITION.BOTTOM_RIGHT,
                                                hideProgressBar: true,
                                                autoClose: 3000,
                                            });
                                        }
                                    } else {
                                        toast.error(t("STORE_CLOSED"), {
                                            position: toast.POSITION.BOTTOM_RIGHT,
                                            hideProgressBar: true,
                                            autoClose: 3000,
                                        });
                                    }
                                } else {
                                    saveDeliveryStore(storeSelected);
                                }
                            } else {
                                if (timeStartMin == 0 || timeEndMin == 0) {  //if store opening or closing minute is 00
                                    if (splitHourArray.length - 1 == splitHourArray.indexOf(futuretime)) {
                                        if (futureMinutes < timeEndMin) {
                                            saveDeliveryStore(storeSelected);
                                        } else {
                                            if (storeSelected.mainStoreId.length > 0 && storeSelected.mainStoreId[0].backupStoreId.backup_zone_id) {
                                                if (geolib.isPointInPolygon({ latitude: lat, longitude: lng }, JSON.parse(storeSelected.mainStoreId[0].backupStoreId.backup_zone_id.zone_json))) {
                                                    saveDeliveryStore(storeSelected.mainStoreId[0].backupStoreId);
                                                } else {
                                                    toast.error(t("STORE_CLOSED"), {
                                                        position: toast.POSITION.BOTTOM_RIGHT,
                                                        hideProgressBar: true,
                                                        autoClose: 3000,
                                                    });
                                                }
                                            } else {
                                                toast.error(t("STORE_CLOSED"), {
                                                    position: toast.POSITION.BOTTOM_RIGHT,
                                                    hideProgressBar: true,
                                                    autoClose: 3000,
                                                });
                                            }
                                        }
                                    } else {
                                        saveDeliveryStore(storeSelected);
                                    }
                                } else { //if store opening or closing minute is not 00
                                    if (
                                        futureMinutes > timeStartMin ||
                                        futureMinutes < timeEndMin
                                    ) {
                                        saveDeliveryStore(storeSelected);
                                    } else {
                                        if (storeSelected.mainStoreId.length > 0 && storeSelected.mainStoreId[0].backupStoreId.backup_zone_id) {
                                            if (geolib.isPointInPolygon({ latitude: lat, longitude: lng }, JSON.parse(storeSelected.mainStoreId[0].backupStoreId.backup_zone_id.zone_json))) {
                                                saveDeliveryStore(storeSelected.mainStoreId[0].backupStoreId);
                                            } else {
                                                toast.error(t("STORE_CLOSED"), {
                                                    position: toast.POSITION.BOTTOM_RIGHT,
                                                    hideProgressBar: true,
                                                    autoClose: 3000,
                                                });
                                            }
                                        } else {
                                            toast.error(t("STORE_CLOSED"), {
                                                position: toast.POSITION.BOTTOM_RIGHT,
                                                hideProgressBar: true,
                                                autoClose: 3000,
                                            });
                                        }
                                    }
                                }
                            }
                        } else {
                            if (storeSelected.mainStoreId.length > 0 && storeSelected.mainStoreId[0].backupStoreId.backup_zone_id) {
                                if (geolib.isPointInPolygon({ latitude: lat, longitude: lng }, JSON.parse(storeSelected.mainStoreId[0].backupStoreId.backup_zone_id.zone_json))) {
                                    saveDeliveryStore(storeSelected.mainStoreId[0].backupStoreId);
                                } else {
                                    toast.error(t("STORE_CLOSED"), {
                                        position: toast.POSITION.BOTTOM_RIGHT,
                                        hideProgressBar: true,
                                        autoClose: 3000,
                                    });
                                }
                            } else {
                                toast.error(t("STORE_CLOSED"), {
                                    position: toast.POSITION.BOTTOM_RIGHT,
                                    hideProgressBar: true,
                                    autoClose: 3000,
                                });
                            }
                        }
                    }
                })
            } else {
                toast.error(t("INVALID_DEVICE_TIME"), {
                    position: toast.POSITION.TOP_RIGHT,
                    hideProgressBar: true,
                    autoClose: 3000,
                });
            }
        })
    }
    //Now Case
    const compareOpenClosingTime = (storeSelected: any) => {
        props.getTimezone(storeSelected.store_id).then((serverTime: any) => {
            //convert the current time 24 hour to 12 hour
            let CurrentHours: any = serverTime.split(":")[0];
            let currentMinutes: any = serverTime.split(":")[1];
            let CurrentAmOrPm = CurrentHours >= 12 ? 'pm' : 'am';
            CurrentHours = CurrentHours % 12 || 12;
            let Currenttime: any = CurrentHours + '' + CurrentAmOrPm;
            //define hours or minutes
            var timeStartMin = new Date(
                '01/01/2007 ' + storeSelected.store_open_time,
            ).getMinutes();
            var timeEndMin = new Date(
                '01/01/2007 ' + storeSelected.store_close_time,
            ).getMinutes();
            var timeStartHours = new Date(
                '01/01/2007 ' + storeSelected.store_open_time,
            ).getHours();
            var timeEndHours = new Date(
                '01/01/2007 ' + storeSelected.store_close_time,
            ).getHours();
            var hourDiff: any = timeEndHours - timeStartHours;
            let HourString = HoursArray(hourDiff, timeStartHours);
            let splitHourArray = HourString.split(":")
            if (splitHourArray.indexOf(Currenttime) !== -1) { //if Pick Hour with am/pm is exist in HourString
                if (timeStartMin == 0 && timeEndMin == 0) {  //if store opening minutes and closing minutes are 00
                    if (splitHourArray.length - 1 == splitHourArray.indexOf(Currenttime)) {
                        //if Pick Hour with am/pm is exist in HourString at last index
                        if (storeSelected.mainStoreId.length > 0 && storeSelected.mainStoreId[0].backupStoreId.backup_zone_id) {
                            if (geolib.isPointInPolygon({ latitude: lat, longitude: lng }, JSON.parse(storeSelected.mainStoreId[0].backupStoreId.backup_zone_id.zone_json))) {
                                saveDeliveryStore(storeSelected.mainStoreId[0].backupStoreId);
                            } else {
                                toast.error(t("STORE_CLOSED"), {
                                    position: toast.POSITION.BOTTOM_RIGHT,
                                    hideProgressBar: true,
                                    autoClose: 3000,
                                });
                            }
                        } else {
                            toast.error(t("STORE_CLOSED"), {
                                position: toast.POSITION.BOTTOM_RIGHT,
                                hideProgressBar: true,
                                autoClose: 3000,
                            });
                        }
                    } else {
                        saveDeliveryStore(storeSelected);
                    }
                } else {
                    if (timeStartMin == 0 || timeEndMin == 0) {  //if store opening or closing minute is 00
                        if (splitHourArray.length - 1 == splitHourArray.indexOf(Currenttime)) {
                            if (currentMinutes < timeEndMin) {
                                saveDeliveryStore(storeSelected);
                            } else {
                                if (storeSelected.mainStoreId.length > 0 && storeSelected.mainStoreId[0].backupStoreId.backup_zone_id) {
                                    if (geolib.isPointInPolygon({ latitude: lat, longitude: lng }, JSON.parse(storeSelected.mainStoreId[0].backupStoreId.backup_zone_id.zone_json))) {
                                        saveDeliveryStore(storeSelected.mainStoreId[0].backupStoreId);
                                    } else {
                                        toast.error(t("STORE_CLOSED"), {
                                            position: toast.POSITION.BOTTOM_RIGHT,
                                            hideProgressBar: true,
                                            autoClose: 3000,
                                        });
                                    }
                                } else {
                                    toast.error(t("STORE_CLOSED"), {
                                        position: toast.POSITION.BOTTOM_RIGHT,
                                        hideProgressBar: true,
                                        autoClose: 3000,
                                    });
                                }
                            }
                        } else {
                            saveDeliveryStore(storeSelected);
                        }
                    } else { //if store opening or closing minute is not 00
                        if (
                            currentMinutes > timeStartMin ||
                            currentMinutes < timeEndMin
                        ) {
                            saveDeliveryStore(storeSelected);
                        } else {
                            if (storeSelected.mainStoreId.length > 0 && storeSelected.mainStoreId[0].backupStoreId.backup_zone_id) {
                                if (geolib.isPointInPolygon({ latitude: lat, longitude: lng }, JSON.parse(storeSelected.mainStoreId[0].backupStoreId.backup_zone_id.zone_json))) {
                                    saveDeliveryStore(storeSelected.mainStoreId[0].backupStoreId);
                                } else {
                                    toast.error(t("STORE_CLOSED"), {
                                        position: toast.POSITION.BOTTOM_RIGHT,
                                        hideProgressBar: true,
                                        autoClose: 3000,
                                    });
                                }
                            } else {
                                toast.error(t("STORE_CLOSED"), {
                                    position: toast.POSITION.BOTTOM_RIGHT,
                                    hideProgressBar: true,
                                    autoClose: 3000,
                                });
                            }
                        }
                    }
                }
            } else {
                if (storeSelected.mainStoreId.length > 0 && storeSelected.mainStoreId[0].backupStoreId.backup_zone_id) {
                    if (geolib.isPointInPolygon({ latitude: lat, longitude: lng }, JSON.parse(storeSelected.mainStoreId[0].backupStoreId.backup_zone_id.zone_json))) {
                        saveDeliveryStore(storeSelected.mainStoreId[0].backupStoreId);
                    } else {
                        toast.error(t("STORE_CLOSED"), {
                            position: toast.POSITION.BOTTOM_RIGHT,
                            hideProgressBar: true,
                            autoClose: 3000,
                        });
                    }
                } else {
                    toast.error(t("STORE_CLOSED"), {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        hideProgressBar: true,
                        autoClose: 3000,
                    });
                }
            }
        })
    }
    const compareTimingbyEachDay = (storeSelected: any, channel: any) => {
        props.getTimezoneForLater(storeSelected.store_id).then((serverTime: any) => {
            let dateIndexServer = serverTime.date.indexOf("T")
            let serverDate = serverTime.date.slice(0, dateIndexServer)

            let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            let weekDaysTimingArr = JSON.parse(storeSelected.channel_days_timing)
            let todayDay = new Date(serverDate).getDay();
            let dayName = days[todayDay];


            weekDaysTimingArr.map((storeDay: any) => {
                if (dayName == storeDay.day) {
                    let timePeriods = storeDay.timePeriods;
                    let storeOpenTime = null;
                    let storeCloseTime = null;
                    timePeriods.map((period: any) => {
                        if (period.channel == channel) {
                            storeOpenTime = period.opening;
                            storeCloseTime = period.closing;
                        }
                    })
                    let today = new Date();

                    let CurrentHours: any = serverTime.time.split(":")[0]
                    let currentMinutes: any = serverTime.time.split(":")[1]
                    let CurrentAmOrPm = CurrentHours >= 12 ? 'pm' : 'am';
                    CurrentHours = CurrentHours % 12 || 12;
                    let Currenttime: any = CurrentHours + '' + CurrentAmOrPm;
                    //define hours or minutes
                    var timeStartMin = new Date(
                        '01/01/2007 ' + storeOpenTime,
                    ).getMinutes();
                    var timeEndMin = new Date(
                        '01/01/2007 ' + storeCloseTime,
                    ).getMinutes();
                    var timeStartHours = new Date(
                        '01/01/2007 ' + storeOpenTime,
                    ).getHours();
                    var timeEndHours = new Date(
                        '01/01/2007 ' + storeCloseTime,
                    ).getHours();
                    var hourDiff: any = timeEndHours - timeStartHours;
                    let HourString = HoursArray(hourDiff, timeStartHours);
                    let splitHourArray = HourString.split(":")

                    if (splitHourArray.indexOf(Currenttime) !== -1) { //if Pick Hour with am/pm is exist in HourString
                        if (timeStartMin == 0 && timeEndMin == 0) {  //if store opening minutes and closing minutes are 00
                            if (splitHourArray.length - 1 == splitHourArray.indexOf(Currenttime)) {
                                //if Pick Hour with am/pm is exist in HourString at last index
                                if (storeSelected.mainStoreId.length > 0 && storeSelected.mainStoreId[0].backupStoreId.backup_zone_id) {
                                    if (geolib.isPointInPolygon({ latitude: lat, longitude: lng }, JSON.parse(storeSelected.mainStoreId[0].backupStoreId.backup_zone_id.zone_json))) {
                                        saveDeliveryStore(storeSelected.mainStoreId[0].backupStoreId);
                                    } else {
                                        toast.error(t("STORE_CLOSED"), {
                                            position: toast.POSITION.BOTTOM_RIGHT,
                                            hideProgressBar: true,
                                            autoClose: 3000,
                                        });
                                    }
                                } else {
                                    toast.error(t("STORE_CLOSED"), {
                                        position: toast.POSITION.BOTTOM_RIGHT,
                                        hideProgressBar: true,
                                        autoClose: 3000,
                                    });
                                }
                            } else {
                                saveDeliveryStore(storeSelected);
                            }
                        } else {
                            if (timeStartMin == 0 || timeEndMin == 0) {  //if store opening or closing minute is 00
                                if (splitHourArray.length - 1 == splitHourArray.indexOf(Currenttime)) {
                                    if (currentMinutes < timeEndMin) {
                                    } else {
                                        if (storeSelected.mainStoreId.length > 0 && storeSelected.mainStoreId[0].backupStoreId.backup_zone_id) {
                                            if (geolib.isPointInPolygon({ latitude: lat, longitude: lng }, JSON.parse(storeSelected.mainStoreId[0].backupStoreId.backup_zone_id.zone_json))) {
                                                saveDeliveryStore(storeSelected.mainStoreId[0].backupStoreId);
                                            } else {
                                                toast.error(t("STORE_CLOSED"), {
                                                    position: toast.POSITION.BOTTOM_RIGHT,
                                                    hideProgressBar: true,
                                                    autoClose: 3000,
                                                });
                                            }
                                        } else {
                                            toast.error(t("STORE_CLOSED"), {
                                                position: toast.POSITION.BOTTOM_RIGHT,
                                                hideProgressBar: true,
                                                autoClose: 3000,
                                            });
                                        }
                                    }
                                } else {
                                    saveDeliveryStore(storeSelected);
                                }
                            } else { //if store opening or closing minute is not 00
                                if (
                                    currentMinutes > timeStartMin ||
                                    currentMinutes < timeEndMin
                                ) {
                                    saveDeliveryStore(storeSelected);
                                } else {
                                    if (storeSelected.mainStoreId.length > 0 && storeSelected.mainStoreId[0].backupStoreId.backup_zone_id) {
                                        if (geolib.isPointInPolygon({ latitude: lat, longitude: lng }, JSON.parse(storeSelected.mainStoreId[0].backupStoreId.backup_zone_id.zone_json))) {
                                            saveDeliveryStore(storeSelected.mainStoreId[0].backupStoreId);
                                        } else {
                                            toast.error(t("STORE_CLOSED"), {
                                                position: toast.POSITION.BOTTOM_RIGHT,
                                                hideProgressBar: true,
                                                autoClose: 3000,
                                            });
                                        }
                                    } else {
                                        toast.error(t("STORE_CLOSED"), {
                                            position: toast.POSITION.BOTTOM_RIGHT,
                                            hideProgressBar: true,
                                            autoClose: 3000,
                                        });
                                    }
                                }
                            }
                        }
                    } else {
                        if (storeSelected.mainStoreId.length > 0 && storeSelected.mainStoreId[0].backupStoreId.backup_zone_id) {
                            if (geolib.isPointInPolygon({ latitude: lat, longitude: lng }, JSON.parse(storeSelected.mainStoreId[0].backupStoreId.backup_zone_id.zone_json))) {
                                saveDeliveryStore(storeSelected.mainStoreId[0].backupStoreId);
                            } else {
                                toast.error(t("STORE_CLOSED"), {
                                    position: toast.POSITION.BOTTOM_RIGHT,
                                    hideProgressBar: true,
                                    autoClose: 3000,
                                });
                            }
                        } else {
                            toast.error(t("STORE_CLOSED"), {
                                position: toast.POSITION.BOTTOM_RIGHT,
                                hideProgressBar: true,
                                autoClose: 3000,
                            });
                        }
                    }
                }
            })
        })
    }
    const disableBtn = () => {
        if (selectedAddress)
            return false;
        else return true;
    }
    const { t } = useTranslation();

    return (
        <>
            {delivery_address && <div>
                {
                    (!_.isEmpty(storeSelected) && orderType == "Delivery") && <button onClick={() => handleSelectChannel()} className='pickup-store-name'>
                        <span className='d-flex align-items-center'>
                            <h4>{t("DELIVERINGTO")}</h4>
                        </span>
                        {/* <p>{storeSelected.store_name}</p> */}
                        <p title={domPurify.sanitize(delivery_address)}>{domPurify.sanitize(delivery_address)}</p>
                    </button>
                }
                <Modal show={show} onHide={closeModal} centered backdrop={"static"}>
                    <div className='modal-design'>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                    <Modal.Header className='justify-content-center' closeButton>
                        <Modal.Title className='font-bold'>{t("SELECTYOURLOCATIONFORDELIVERY")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className='w-100 delivery-order'>
                        <DeliveryModal isModalOpen={show} deliveryStoreList={deliveryStoreList} setSaveAddressSelect={setSaveAddressSelect} changeLocation={changeLocation} setChangeLocation={setChangeLocation} savedAddresses={savedAddresses} setAddressData={setAddressData}
                            selectedAddress={selectedAddress} handleOnChange={handleOnChange}
                            setLat={setLat} lat={lat} setLng={setLng} lng={lng} setPosition={setPosition} position={position}
                            setOrderTime={setOrderTime} orderTime={orderTime} setLaterDate={setLaterDate} laterdatetime={laterdatetime}
                            setValidTimeFlag={setValidTimeFlag} setSaveAddress={setSaveAddress} saveAddressCheck={saveAddressCheck} setPlace={setPlace} place={place}
                            setSearchString={setSearchString}
                            setExtraDetails={setExtraDetails} extra_details={extraDetails} setStreetName={setStreetName} setStreetNumber={setStreetNumber} street_name={streetName} street_number={streetNumber} searchString={searchString} setConfirmAddress={setConfirmAddress} confirmAdd={confirmAdd}
                            closeDeliveryOpenPickup={() => {
                                closeModal();
                                setTimeout(() => {
                                    const pickupBtn = document.querySelector('.order-options button:not(.option-active)') as HTMLButtonElement;
                                    if (pickupBtn) pickupBtn.click();
                                }, 300);
                            }} />
                        <Button disabled={!deliveryOrderReady()} onClick={() => {
                            confirmLocation()
                        }} className={`${!deliveryOrderReady() ? "disable-btn" : "able-btn"}
                     'm-auto d-flex mt-4 bg-theme w-100 deliver-btn'`} variant="contained"
                            color="error" style={{
                                zIndex: 9999, textTransform: 'none', cursor: deliveryOrderReady() ?
                                    "pointer" : "no-drop", backgroundColor: deliveryOrderReady() ? "rgb(0,105,145)" : "rgb(128, 128, 128)"
                            }}>{t("STARTYOURORDER")}</Button>
                    </Modal.Body>
                    <Modal.Footer className='d-flex justify-content-center my-3'>
                        {!isLogged &&
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <span className='already-user mx-3'>{t("ALREADYAUSER")}</span><Link onClick={closeModal} to={`${lang}/login`}><span>{t("LOGIN")}</span></Link>
                            </div>
                        }
                    </Modal.Footer>
                </Modal>
                <Modal className='track-modal border-0' show={open} onHide={cartCloseModal} centered >
                    <div className='modal-design'>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                    <Modal.Body className='p-0'>
                        <div className="px-4 mt-0">
                            <div className="mt-3">
                                <div className='text-center'>
                                    <span>
                                        <i className="ri-error-warning-line" style={{ fontSize: "70px", color: "rgba(228, 24, 55, 1)" }}></i>
                                    </span>
                                    <h5 className='f-w-500 p-1 mb-0'>{t("IFYOUCHANGETHESTORETHECARTWILLRESET")}</h5>
                                    <h5 className='f-w-500 p-1'>{t("DOYOUWANTTOCONTINUE")}</h5>
                                </div>
                            </div>
                            <div className='d-flex pb-4 pt-3 justify-content-center gap-10' >
                                <Button variant="contained" color="error" className='confiramtion-btns bg-theme' style={{ cursor: "pointer", backgroundColor: "rgba(228, 24, 55, 1)" }} onClick={() => {
                                    handleCartRemove();
                                }}>{t("YES")}</Button>
                                <Button variant="contained" color="error" className='confiramtion-btns bg-theme' onClick={() => cartCloseModal()}>{t("NO")}</Button>
                            </div>
                        </div>
                    </Modal.Body>

                </Modal>
            </div>
            }
        </>
    )
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        getDeliveryStores: function () {
            dispatch(getDeliveryStores());
        },
        addAddressUser: (data: any) => {
            dispatch(addAddressUser(data))
        },
        saveOrderType: function (type: any) {
            dispatch(saveOrderType(type));
        },
        saveOrderTime: function (type: any) {
            dispatch(saveOrderTime(type));
        },
        saveOrderLaterDateTime: (dateTime: any) => {
            dispatch(saveOrderLaterDateTime(dateTime));
        },
        saveDeliveryAddress: (address: any) => {
            dispatch(saveDeliveryAddress(address))
        },
        saveGeoCodedAddress: (address: any) => {
            dispatch(saveGeoCodedAddress(address))
        },
        saveExtraAddress: (address: any) => {
            dispatch(saveExtraAddress(address))
        },
        saveSelectStoreId: (store: any) => {
            dispatch(saveSelectStoreId(store));
        },
        getTimezone: function (id: number) {
            return dispatch(getTimezone(id))
        },
        getTimezoneForLater: function (id: number) {
            return dispatch(getTimezoneForLater(id))
        },
        addressesList: function () {
            dispatch(addressesList());
        },
        storeMenuItemCall: (store_id: any, orderType: any, pathname: string, locale: string) => {
            dispatch(storeMenuItemCall(store_id, orderType, pathname, locale))
        },
        saveCart: function (cart: any[]) {
            dispatch(saveCart(cart));
        },
        setPositionProps: function (obj: any) {
            dispatch(setPositionProps(obj))
        },
        setSearchStringProps: function (value: any) {
            dispatch(setSearchStringProps(value))
        },
        saveStorePosFee: function (fee: any) {
            dispatch(saveStorePosFee(fee))
        },
        removeCoupon: function () {
            dispatch(removeCoupon())
        }
    };
};

export default connect(null, mapDispatchToProps)(DeliveryFor);
